import React from 'react';

import { Label } from '@/components/shared/Inputs/Label/Label';
import { ModalSectionCard } from '@/components/shared/ModalSectionCard';

import styles from './FeedbackPanel.module.scss';

export const FeedbackSection: React.FC<{
	title: string;
	subtitle: string;
}> = ({ title, subtitle, children }) => {
	return (
		<div className={styles['feedback-section']}>
			<Label tooltip={subtitle} tooltipHeading={title} className={styles['section-label']}>
				{title}
			</Label>
			<ModalSectionCard borderRadiusSize="sm" className={styles['input-card']}>
				{children}
			</ModalSectionCard>
		</div>
	);
};
